import { JSONSchema7 } from "json-schema";

export enum IntegrationName {
  AdobeSign = "ADOBESIGN",
  AdobeSignOauth = "ADOBESIGN_OAUTH2",
  DocuSign = "DOCUSIGN",
  DocuSignOauth = "DOCUSIGN_OAUTH2",
  HubSpot = "HUBSPOT",
  OpenId = "OPENID",
  Salesforce = "SALESFORCE",
  LegalSifterReview = "LEGALSIFTER_REVIEW",
  SalesforcePackage = "SALESFORCE_PACKAGE",
  SSOSelfService = "SSO_SELF_SERVICE",
}

export interface IntegrationConfig {
  signatureProvider: IntegrationName;
  oAuthProvider: IntegrationName;
  hasLoaded: boolean;
}

export interface SsoIntegrationConfig {
  ssoProvider: IntegrationName;
  hasLoaded: boolean;
}

export enum IntegrationType {
  Crawler = "CRAWLER",
  CRM = "CRM",
  Signature = "SIGNATURE",
  SSO = "SSO",
}

export interface Integration {
  id: number;
  name: IntegrationName;
  type: IntegrationType;
  description: string;
  options: JSONSchema7;
}

export interface Configuration {
  companyId: number;
  id: number;
  integrationId: number;
  integrationName: IntegrationName;
  integrationType: IntegrationType;
  options: any;
}

export function getIntegrationName(configuration: Configuration) {
  return configuration?.integrationName;
}
